import { Module } from "vuex";
import { RootState } from "@/store/types";
import { cdpStatistic } from "@/store/cdp/statistic";
import { cdpClientAttributes } from "@/store/cdp/client_attributes";
import { cdpEventAttributes } from "@/store/cdp/event_attributes";

export const cdpModule: Module<any, RootState> = {
  modules: {
    cdpStatistic,
    cdpClientAttributes,
    cdpEventAttributes
  },
};
